import PriceSummarySection from '../IdfSaleBlock/Constans/PriceSummarySection/PriceSummarySection';
import React from 'react';
import { connect } from 'react-redux';
import { PortalStep } from './Enum';
import { setCurrentStep, UpdateOrgUserDetails } from './OrganizationPortalSlice';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import { cgTypeEnum } from '../../../utilities/enums/cgTypeEnum';
import { GetCreditCardTypeId } from '../IdfSaleBlock/IdfSaleEnums';

function OrgOrderSummary({ data, setCurrentStep, UpdateOrgUserDetails, payment, orgDetails }) {

  const selectedPlan = data.userDetails.selectedPlan;
  const userActionType = data.userDetails.actionType;
  const productsList = userActionType === 'upgrade' ? [] : [{ name: 'כרטיס סים', price: '0' }];
  const isProductSelected = selectedPlan.model.itemId ?? null;
  isProductSelected &&
    productsList.push({
      name: selectedPlan.model.name + '  ' + selectedPlan.model.storage + 'GB , ' + selectedPlan.model.color,
      price: selectedPlan.model.price,
      numOfPayments: payment.numOfPayments,
    });
  const isUpdateAction = data.userDetails.ban != '';

  const onEdit = (step) => {
    setCurrentStep({ current: step, previous: PortalStep.OrderSummary });
  };

  const handleSubmit = async () => {
    await UpdateOrgUserDetails({ ...data });
  };

  return (
    <div className='OrderSummary'>
      <div className='M_Title'> סיכום פרטי הזמנה</div>
      <div className='S_SubTitle'> נא אשרו שכל הפרטים תקינים</div>
      <div className='step-page_S'>
        <div>
          <div className='section'>
            <PriceSummarySection title='פרטים אישיים' />
            <span className='section-item'>{data.userDetails.firstName + ' ' + data.userDetails.lastName}</span>
            <span className='section-item'>{data.userDetails.phoneNumber}</span>
            {!isUpdateAction && userActionType === 'activate' && (
              <span className='section-item'>
                {data.userDetails.address.city + ' ' + data.userDetails.address.street + ' ' + data.userDetails.address.houseNum}
              </span>
            )}
          </div>
          <div className='section'>
            <PriceSummarySection
              title='מוצרים'
              onEdit={isProductSelected ? () => onEdit(PortalStep.ProductSelection) : false}
              products={productsList}
            />
          </div>
          {isUpdateAction && userActionType === 'activate' && (<div className='section'>
            <PriceSummarySection
              title='חבילת גלישה'
              products={[{ name: selectedPlan.package.packageName, price: selectedPlan.package.price, monthly: true }]}
            />
          </div>)}
          {!isUpdateAction && userActionType === 'activate' && (
            <div className='section'>
              <PriceSummarySection title='פרטי אמצעי תשלום' onEdit={() => onEdit(PortalStep.UserPaymentInfo)} />
              {payment.PType == cgTypeEnum.DEBTPAYMENT ? (
                <>
                  <span className='section-item'>{payment.Bank.bankName + ' ' + payment.Bank.bankCode}</span>
                  <span className='section-item'> סניף: {payment.Bank.branchCode}</span>
                  <span className='section-item'> מס חשבון: {payment.Bank.bankAccountNo}</span>
                </>
              ) : (
                <>
                  <span className='section-item'>סוג כרטיס: {GetCreditCardTypeId(payment.CreditCard.ccType)}</span>
                  <span className='section-item'> מספר כרטיס: {payment.CreditCard.credit4Digits}************</span>
                  <span className='section-item'> תוקף: {payment.CreditCard.cardDueMonth + '/' + payment.CreditCard.cardDueYear}</span>
                  <span className='section-item'> מס ת.ז: {data.userDetails.userId}</span>
                </>
              )}
            </div>
          )}
          {userActionType === 'upgrade' && (
            <div className='section'>
              <PriceSummarySection title='פרטי אמצעי תשלום' />
              <span className='section-item'> מספר כרטיס: {payment.CreditCard.credit4Digits}************</span>
            </div>
          )}
          <div className='section'>
            <PriceSummarySection title='מרכז חלוקה' onEdit={() => onEdit(PortalStep.DistributionCenter)} />
            <span className='section-item'>{data.userDetails.selectedDCenter}</span>
          </div>
         {userActionType === 'upgrade' && orgDetails.orderSummaryNote != '' && <div>
            <span className='section-item'>{orgDetails.orderSummaryNote}</span>
          </div>}
        </div>
      </div>
      <BtnSubmit text={'הכל תקין, ההזמנה מאושרת'} onclick={() => handleSubmit()} />
    </div>
  );
}

const mapStateToProps = (state) => ({
  data: state.organizationPortal,
  payment: state.organizationPortal.userDetails.payment,
  orgDetails: state.organizationPortal.orgDetails,
});

const mapDispatchToProps = {
  setCurrentStep,
  UpdateOrgUserDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrgOrderSummary);
